import React from 'react';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Box } from '@mui/material';
import { useLocalStorageJson } from '../../hooks/useLocalStorageJson';

const StyledDataGrid = (props) => {
  const {
    rows,
    columns,
    rowModesModel,
    onRowModesModelChange,
    onRowEditStop,
    processRowUpdate,
    onRowClick,
    onRowDoubleClick,
    getRowClassName,
    noRowsOverlay,
    toolbar,
    isLoading,
    handleOpen,
    height,
    filterState, // Pass filterState here
    setFilterState, // Pass setFilterState here
    setOpenHeatingPanicDialog,
  } = props;

  const [dataGridState, setDataGridState] = useLocalStorageJson(
    `${props.rowsName}-DataGrid-Presets`,
    {
      presets: [{ name: 'Default', visibilityList: {}, density: 'compact' }],
      chosenPreset: 0,
    },
  );

  const handleVisibilityChange = (e) => {
    setDataGridState((prevState) => ({
      ...prevState,
      presets: dataGridState.presets.map((preset, index) =>
        index === dataGridState.chosenPreset
          ? { ...preset, visibilityList: e }
          : preset,
      ),
    }));
  };

  const handleDensityChange = (newDensity) => {
    setDataGridState((prevState) => ({
      ...prevState,
      presets: dataGridState.presets.map((preset, index) =>
        index === dataGridState.chosenPreset
          ? { ...preset, density: newDensity }
          : preset,
      ),
    }));
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <DataGridPremium
        rows={rows || []}
        columns={columns}
        pagination
        initialState={{
          density: 'compact',
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        }}
        onColumnVisibilityModelChange={(newModel) =>
          handleVisibilityChange(newModel)
        }
        columnVisibilityModel={{
          // Hide columns using the dataGridState state from local storage
          ...dataGridState.presets[dataGridState.chosenPreset].visibilityList,
        }}
        onDensityChange={(density) => handleDensityChange(density)}
        density={dataGridState.presets[dataGridState.chosenPreset].density}
        rowModesModel={rowModesModel}
        onRowModesModelChange={onRowModesModelChange}
        onRowEditStop={onRowEditStop}
        processRowUpdate={processRowUpdate}
        onRowClick={onRowClick}
        onRowDoubleClick={onRowDoubleClick}
        getRowClassName={getRowClassName}
        isLoading={isLoading}
        slots={{ noRowsOverlay: noRowsOverlay, toolbar: toolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            handleOpen: handleOpen,
            filterState, // Pass filterState here
            setFilterState, // Pass setFilterState here
            dataGridState: dataGridState,
            setDataGridState: setDataGridState,
            setOpenHeatingPanicDialog: setOpenHeatingPanicDialog,
          },
          noRowsOverlay: {
            rows: props.rowsName,
            isLoading: isLoading,
          },
        }}
        pageSizeOptions={[10, 20, 50, 100]}
        disableRowSelectionOnClick
        disableSelectionOnClick
        sx={{
          height: height || 600,
          border: 'none',
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
            {
              outline: 'none',
            },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
          },
          '& .MuiDatagrid-root': {
            // borderBottom: 'none !important',
            border: 0,
          },
          '.MuiDataGrid-withBorderColor': {
            border: 'none !important',
          },
          '& .MuiDatagrid-footerContainer': {
            border: 0,
          },
          '& .MuiDatagrid-bottomContainer': {
            border: 0,
          },
          '& .MuiDataGrid-main': {
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? '#fff' : '#121212',
            // boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%)",
            borderRadius: 2,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          },
          '& .MuiDataGrid-columnHeaders': {
            // backgroundColor: 'blue', // Background color for column headers
            // color: 'white', // Text color
            // fontSize: '1rem', // Adjust font size if needed
            borderBottom: '1px solid', // Optional: Add a border
            borderColor: 'divider',
          },
          '& .MuiDataGrid-columnsContainer': {
            backgroundColor: 'blue',
            // backgroundColor: (theme) => theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
          },
          '& .selected-row': {
            backgroundColor: (theme) => theme.palette.action.selected,
            '&:hover': {
              backgroundColor: (theme) => theme.palette.action.selected,
            },
          },
          '& .MuiDataGrid-scrollbar': {
            overflow: 'hidden !important',
          },
        }}
      />
    </Box>
  );
};

export default StyledDataGrid;
